export default __webpack_public_path__ + "static/media/Spring21_06.6da21c75.png";